import { FC } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { CiWarning } from 'react-icons/ci';
import { ReactComponent as InfoIconSvg } from '../../assets/icons/info.svg';
const Message: FC<React.PropsWithChildren<MessageProps>> = ({
  message,
  variant,
}) => {
  const theme = useTheme();
  let icon: null | React.ReactElement = null;
  let backgroundColor = '';
  let color = '';
  switch (variant) {
    case 'warning':
      icon = <CiWarning color='red' />;
      backgroundColor = theme.palette.warning.light;
      color = '#000';
      break;
    default:
      icon = <InfoIconSvg color={theme.palette.text.secondary} />;
      backgroundColor = theme.palette.background.default;
      color = 'text.primary';
  }
  return (
    <Box
      sx={{ backgroundColor }}
      p={2}
      gap={1}
      borderRadius={1}
      display='flex'
      flexDirection='row'>
      {icon}
      <Typography variant='body2' color={color}>
        {message}
      </Typography>
    </Box>
  );
};

export interface MessageProps {
  message: string;
  variant?: 'info' | 'warning' | 'error';
}

export default Message;
